import { useEffect } from 'react'
import s from './Exports.scss'
import { useImmer } from 'use-immer'
import { AddOptions } from 'components/ideal-core-ui'
import { getTenant, getToken } from 'utils/authService'

const Exports = ({ saveDetails, details }) => {
  const [organizationDetails, setOrganizationDetails] = useImmer(details)
  const { dataExportSettings } = organizationDetails

  useEffect(() => {
    setOrganizationDetails(() => {
      return details
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [details])

  useEffect(() => {
    if (organizationDetails.shouldSave) {
      saveDetails(organizationDetails)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationDetails])

  return (
    <>
      <h5>Data Exports</h5>
      <p className={s.description}>
        You have the option to schedule a recurring data export from iDeal CRM for your records. The
        export will be delivered to one or more email addresses as a ZIP folder with several Excel
        files in it. It contains all your opportunities, client companies, and contacts.
        <br />
        <br />
        The email will be delivered every Saturday at 6:00 a.m. U.S. EST
      </p>
      <div className={s.inputContainer}>
        <input
          type="radio"
          checked={dataExportSettings?.enabled ?? false}
          onChange={() => {
            setOrganizationDetails(draft => {
              draft.dataExportSettings.enabled = true
              draft.shouldSave = true
            })
          }}
        />{' '}
        On
      </div>
      <div className={s.inputContainer}>
        <input
          type="radio"
          checked={dataExportSettings ? !dataExportSettings.enabled : true}
          onChange={() => {
            setOrganizationDetails(draft => {
              draft.dataExportSettings.enabled = false
              draft.shouldSave = true
            })
          }}
        />{' '}
        Off
      </div>
      <AddOptions
        styles={{ marginTop: 20 }}
        allowEmpty
        texts={{
          subtitle: 'Add recipient email addresses',
          placeholder: 'Enter Email Address'
        }}
        items={dataExportSettings.recipients ?? []}
        addItem={(items, itemName) => {
          setOrganizationDetails(draft => {
            draft.dataExportSettings.recipients = [...items, itemName]
            draft.shouldSave = true
          })
        }}
        deleteItem={(item, items) => {
          const index = items.findIndex(d => d === item)
          const tmp = [...items]
          tmp.splice(index, 1)
          setOrganizationDetails(draft => {
            draft.dataExportSettings.recipients = tmp
            draft.shouldSave = true
          })
        }}
        validation={email => {
          return email.match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          )
        }}
      />
      {getTenant() === 'skaepowersolutionsllc' && (
        <a
          href={`https://api.web.idealcrm.app/v1/deal-files-export?x-token-tracking=${getToken()}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Download all data
        </a>
      )}
    </>
  )
}

export default Exports
